<template>
  <app-side-menu>
    <aside
      class="menu"
      slot="side-menu">
      <p class="menu-label">
        <span class="title is-6">Filters</span>
      </p>
      <ul class="menu-list">
        <li>
          <div class="field">
            <div class="control">
              <div class="select">
                <select v-model="value.BodyID">
                  <option
                    v-for="(BodyID, propertyName, index) in PartsCatalogBodyIDTypeEnum"
                    :value="propertyName"
                    :key="index">
                    {{ BodyID }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <div class="select">
                <select v-model="value.BodyType">
                  <option
                    v-for="(BodyType, propertyName, index) in PartsCatalogBodyTypeEnum"
                    :value="propertyName"
                    :key="index">
                    {{ BodyType }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <hr>
      <div class="field is-grouped is-pulled-right">
        <div class="control">
          <button
            class="button is-primary"
            @click="onFilterClick">
            <span class="icon">
              <i class="mdi mdi-magnify mdi-18px" />
            </span>
            <span>Filter</span>
          </button>
        </div>
        <div class="control">
          <button
            class="button"
            @click="onResetClick">
            <span class="icon">
              <i class="mdi mdi-refresh mdi-18px" />
            </span>
            <span>Reset</span>
          </button>
        </div>
      </div>
    </aside>
  </app-side-menu>
</template>

<script>
import AppSideMenu from '@/components/AppSideMenu'
// import { BulmaRadioButton } from '@/components/BulmaRadio'
import _cloneDeep from 'lodash/cloneDeep'
import { mask } from 'vue-the-mask'
import { PartsCatalogBodyIdTypes, PartsCatalogBodyTypes } from '@/enums'

export default {
  name: 'PartsCatalogueSideMenu',
  inject: ['$vv'],
  components: {
    AppSideMenu
    // BulmaRadioButton
  },
  directives: {
    mask
  },
  props: {
    filter: null,
    value: null
  },
  data() {
    return {
      innerValue: _cloneDeep(this.value),
      selectedActive: 1,
      stateList: null
    }
  },
  computed: {
    $v() {
      return this.$vv || this.$v
    },
    PartsCatalogBodyTypeEnum() {
      return PartsCatalogBodyTypes
    },
    PartsCatalogBodyIDTypeEnum() {
      return PartsCatalogBodyIdTypes
    }
  },
  watch: {
    innerValue: {
      handler: function(newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    },
    value: {
      handler: function(newVal, oldVal) {
        this.innerValue = this.value
      },
      deep: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    onFilterClick() {
      this.$emit('filter')
    },
    onResetClick() {
      this.$emit('reset')
    }
  }
}
</script>

<style lang="scss" scoped>
// @use '@/assets/style/mixins/inputs/placeholder' as *;;
// input.uppercase {
//   text-transform: uppercase;
//   @include reset-placeholder-text-transform;
// }
</style>
